import { gql } from '@apollo/client';

export const GET_CHECKLISTS_WITH_PROJECT_DETAILS_BY_PROJECT_ID_QUERY = gql`
  query GetChecklistByProjectId($id: uuid!) {
    projects(
      where: { id: { _eq: $id }, _and: { is_deleted: { _is_null: true } } }
    ) {
      id
      name
      description
      checklists(
        order_by: { updated_at: desc }
        where: {
          parent_id: { _is_null: true }
          _and: { is_deleted: { _is_null: true }, task_id: { _is_null: true } }
        }
      ) {
        id
        title
        parent_id
        created_at
        updated_at
        checklist_version_id
        userByCreatedBy {
          id
          displayName
          email
        }
      }
    }
  }
`;

export const GET_CHECKLISTS_BY_PROJECT_ID_QUERY = gql`
  query GetChecklistByProjectId($id: uuid!) {
    checklist(
      where: {
        project_id: { _eq: $id }
        _and: { parent_id: { _is_null: true } }
      }
    ) {
      id
      title
    }
  }
`;

export const CREATE_PROJECT_MUTATION = gql`
  mutation CreateProject(
    $orgId: uuid!
    $projectName: String!
    $description: String!
  ) {
    insert_projects_one(
      object: { org_id: $orgId, name: $projectName, description: $description }
    ) {
      id
      name
    }
  }
`;

export const CREATE_PROJECT_WITH_MEMBERS_MUTATION = gql`
  mutation CreateProjectWithMembers(
    $projects: [projects_insert_input!]!
    $projectUsers: [project_users_insert_input!]!
  ) {
    insert_projects(objects: $projects) {
      affected_rows
    }
    insert_project_users(objects: $projectUsers) {
      affected_rows
    }
  }
`;

export const UPDATE_PROJECT_MUTATION = gql`
  mutation UpdateProjectMutation($projectId: uuid!, $set: projects_set_input!) {
    update_projects_by_pk(pk_columns: { id: $projectId }, _set: $set) {
      id
      name
    }
  }
`;

export const ADD_A_MEMBER_TO_PROJECT_MUTATION = gql`
  mutation InviteAMemberToProject(
    $projectId: uuid!
    $userId: uuid!
    $customRoleId: uuid!
  ) {
    insert_project_users_one(
      object: {
        project_id: $projectId
        user_id: $userId
        custom_role_id: $customRoleId
      }
    ) {
      id
      project_id
      user_id
    }
  }
`;

export const ADD_MULTIPLE_MEMBERS_TO_PROJECT_MUTATION = gql`
  mutation InviteMultipleMembersToProject(
    $projectUsers: [project_users_insert_input!]!
  ) {
    insert_project_users(objects: $projectUsers) {
      affected_rows
      returning {
        id
        project_id
        user {
          id
          displayName
          email
          avatarUrl
        }
        custom_role_id
        custom_role {
          id
          title
        }
      }
    }
  }
`;

export const GET_PROJECT_USERS_AND_ROLE_QUERY = gql`
  query getProjectUserAndProjectInvites($projectId: uuid!) {
    project_users(where: { project_id: { _eq: $projectId } }) {
      id
      user {
        id
        displayName
        email
        avatarUrl
      }
      custom_role_id
      custom_role {
        id
        title
      }
    }
  }
`;

export const CREATE_MULTIPLE_PROJECTS_AND_ADD_A_MEMBER_MUTATION = gql`
  mutation CreateMultipleProjectsAndInviteAMemberMutation(
    $projects: [projects_insert_input!]!
    $projectUsers: [project_users_insert_input!]!
  ) {
    insert_projects(objects: $projects) {
      affected_rows
    }

    insert_project_users(objects: $projectUsers) {
      affected_rows
    }
  }
`;

export const DELETE_PROJECT_USER_BY_ID_MUTATION = gql`
  mutation DeleteProjectUsersByIdMutation($id: uuid!) {
    delete_project_users_by_pk(id: $id) {
      id
    }
  }
`;

export const UPDATE_PROJECT_USER_ROLE_BY_ID_MUTATION = gql`
  mutation updateProjectUserRoleByIdMutation(
    $id: uuid!
    $set: project_users_set_input!
  ) {
    update_project_users_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
    }
  }
`;

export const GET_PROJECT_USERS_QUERY = gql`
  query getProjectUsersQuery($projectId: uuid!) {
    project_users(where: { project_id: { _eq: $projectId } }) {
      id
      user {
        id
        displayName
        email
      }
    }
  }
`;

export const DELETE_PROJECT_INVITE_BY_ID_MUTATION = gql`
  mutation DeleteProjectInviteByIdMutation($id: uuid!) {
    delete_project_invites_by_pk(id: $id) {
      id
    }
  }
`;

export const DELETE_PROJECT_INVITE_BY_EMAIL_WITH_ORGID_MUTATION = gql`
  mutation DeleteProjectInviteByEmailWithOrgIdMutation(
    $orgId: uuid!
    $email: citext
  ) {
    delete_project_invites(
      where: { email: { _eq: $email }, org_id: { _eq: $orgId } }
    ) {
      affected_rows
    }
  }
`;

export const DELETE_PROJECT_BY_ID_MUTATION = gql`
  mutation DeleteProjectByIdMutation(
    $projectId: uuid!
    $set: projects_set_input!
  ) {
    update_projects_by_pk(pk_columns: { id: $projectId }, _set: $set) {
      id
    }
  }
`;

export const GetProjectActivityQuery = gql`
  query OrgProjectActivityQuery($id: uuid!, $fromDate: timestamptz!) {
    checklist_created: events_aggregate(
      where: {
        project_id: { _eq: $id }
        event_type: { _eq: "checklist_created" }
        created_at: { _gte: $fromDate }
        is_project_deleted: { _is_null: true }
        is_checklist_deleted: { _is_null: true }
      }
    ) {
      aggregate {
        count
      }
    }

    run_created: events_aggregate(
      where: {
        project_id: { _eq: $id }
        event_type: { _eq: "run_created" }
        created_at: { _gte: $fromDate }
        is_checklist_deleted: { _is_null: true }
        is_run_deleted: { _is_null: true }
      }
    ) {
      aggregate {
        count
      }
    }

    run_completed: events_aggregate(
      where: {
        project_id: { _eq: $id }
        event_type: { _eq: "run_completed" }
        created_at: { _gte: $fromDate }
        is_checklist_deleted: { _is_null: true }
        is_run_deleted: { _is_null: true }
      }
    ) {
      aggregate {
        count
      }
    }

    run_overdue: events_aggregate(
      where: {
        project_id: { _eq: $id }
        event_type: { _eq: "run_created" }
        created_at: { _gte: $fromDate }
        is_checklist_deleted: { _is_null: true }
        is_run_deleted: { _is_null: true }
        run_due_at: { _lt: "now()" }
        run: {
          _or: [
            { run_checklist_id: { _is_null: true } }
            {
              run_checklist: {
                _or: [
                  { is_completed: { _eq: false } }
                  { is_completed: { _is_null: true } }
                ]
              }
            }
          ]
        }
      }
    ) {
      aggregate {
        count
      }
    }

    run_inprogress: events_aggregate(
      where: {
        project_id: { _eq: $id }
        event_type: { _eq: "run_inprogress" }
        created_at: { _gte: $fromDate }
        is_checklist_deleted: { _is_null: true }
        is_run_deleted: { _is_null: true }
        run_checklist: {
          _or: [
            { is_completed: { _eq: false } }
            { is_completed: { _is_null: true } }
          ]
        }
      }
    ) {
      aggregate {
        count
      }
    }

    run_pending: events_aggregate(
      where: {
        project_id: { _eq: $id }
        event_type: { _eq: "run_created" }
        created_at: { _gte: $fromDate }
        is_checklist_deleted: { _is_null: true }
        is_run_deleted: { _is_null: true }
        run: {
          _or: [
            { run_checklist_id: { _is_null: true } }
            {
              run_checklist: {
                _or: [
                  { is_completed: { _eq: false } }
                  { is_completed: { _is_null: true } }
                ]
              }
            }
          ]
        }
      }
    ) {
      aggregate {
        count
      }
      nodes {
        run_id
        run_due_at
        checklist {
          id
          title
        }
        user {
          id
          displayName
        }
      }
    }

    timing_events: events(
      where: {
        project_id: { _eq: $id }
        event_type: { _in: ["run_inprogress", "run_completed"] }
        is_run_deleted: { _is_null: true }
        created_at: { _gte: $fromDate }
      }
    ) {
      run_id
      event_type
      created_at
    }
  }
`;

export const GetChecklistActivityByProjectIdQuery = gql`
  query GetChecklistActivityByProjectIdQuery(
    $id: uuid!
    $fromDate: timestamptz!
  ) {
    checklist(
      order_by: { updated_at: desc }
      where: {
        project_id: { _eq: $id }
        parent_id: { _is_null: true }
        _and: { is_deleted: { _is_null: true }, task_id: { _is_null: true } }
      }
      limit: 20
    ) {
      id
      title
      run_created: events_aggregate(
        where: {
          project_id: { _eq: $id }
          event_type: { _eq: "run_created" }
          is_run_deleted: { _is_null: true }
          created_at: { _gte: $fromDate }
        }
      ) {
        aggregate {
          count
        }
      }
      run_completed: events_aggregate(
        where: {
          project_id: { _eq: $id }
          event_type: { _eq: "run_completed" }
          is_run_deleted: { _is_null: true }
          created_at: { _gte: $fromDate }
        }
      ) {
        aggregate {
          count
        }
      }
      run_overdue: events_aggregate(
        where: {
          project_id: { _eq: $id }
          event_type: { _eq: "run_created" }
          is_run_deleted: { _is_null: true }
          run_due_at: { _lt: "now()" }
          created_at: { _gte: $fromDate }
          run: {
            _or: [
              { run_checklist_id: { _is_null: true } }
              {
                run_checklist: {
                  _or: [
                    { is_completed: { _eq: false } }
                    { is_completed: { _is_null: true } }
                  ]
                }
              }
            ]
          }
        }
      ) {
        aggregate {
          count
        }
      }
      run_inprogress: events_aggregate(
        where: {
          project_id: { _eq: $id }
          event_type: { _eq: "run_inprogress" }
          is_run_deleted: { _is_null: true }
          created_at: { _gte: $fromDate }
          run_checklist: {
            _or: [
              { is_completed: { _eq: false } }
              { is_completed: { _is_null: true } }
            ]
          }
        }
      ) {
        aggregate {
          count
        }
      }

      not_started: events_aggregate(
        where: {
          project_id: { _eq: $id }
          event_type: { _eq: "run_created" }
          is_run_deleted: { _is_null: true }
          _not: { run: { events: { event_type: { _eq: "run_inprogress" } } } }
          created_at: { _gte: $fromDate }
        }
      ) {
        aggregate {
          count
        }
      }
    }
  }
`;

export const GetMembersActivityQuery = gql`
  query OrgMembersActivityQuery($id: uuid!, $fromDate: timestamptz!) {
    projects(
      where: { id: { _eq: $id }, is_deleted: { _is_null: true } }
      order_by: { created_at: asc }
    ) {
      id

      run_created: events_aggregate(
        where: {
          project_id: { _eq: $id }
          event_type: { _eq: "run_created" }
          is_project_deleted: { _is_null: true }
          is_checklist_deleted: { _is_null: true }
          is_run_deleted: { _is_null: true }
          created_at: { _gte: $fromDate }
        }
      ) {
        aggregate {
          count
        }
        nodes {
          user {
            displayName
          }
        }
      }
      run_completed: events_aggregate(
        where: {
          project_id: { _eq: $id }
          event_type: { _eq: "run_completed" }
          is_project_deleted: { _is_null: true }
          is_checklist_deleted: { _is_null: true }
          is_run_deleted: { _is_null: true }
          created_at: { _gte: $fromDate }
        }
      ) {
        aggregate {
          count
        }
        nodes {
          user {
            displayName
          }
        }
      }
      run_overdue: events_aggregate(
        where: {
          project_id: { _eq: $id }
          event_type: { _eq: "run_created" }
          is_project_deleted: { _is_null: true }
          is_checklist_deleted: { _is_null: true }
          is_run_deleted: { _is_null: true }
          run_due_at: { _lt: "now()" }
          created_at: { _gte: $fromDate }
        }
      ) {
        aggregate {
          count
        }
        nodes {
          user {
            displayName
          }
        }
      }
      run_inprogress: events_aggregate(
        where: {
          project_id: { _eq: $id }
          event_type: { _eq: "run_inprogress" }
          is_checklist_deleted: { _is_null: true }
          is_run_deleted: { _is_null: true }
          created_at: { _gte: $fromDate }
        }
      ) {
        aggregate {
          count
        }
        nodes {
          user {
            displayName
          }
        }
      }
    }
  }
`;

export const GET_ASSIGN_TO_ME_BY_PROJECT_RUNS_QUERY = gql`
  query GetRuns($userId: uuid!, $projectId: uuid!, $fromDate: timestamptz!) {
    runs(
      where: {
        runs_assignments: { user_id: { _eq: $userId } }
        checklist: {
          project_id: { _eq: $projectId }
          is_deleted: { _is_null: true }
        }
        is_deleted: { _is_null: true }
        checklist_version_id: { _is_null: false }
        created_at: { _gte: $fromDate }
      }
      order_by: { created_at: desc }
    ) {
      name
      user {
        displayName
        email
      }
    }
  }
`;

export const GET_ASSIGN_TO_OTHERS_BY_PROJECT_RUNS_QUERY = gql`
  query GetOthersRuns(
    $userId: uuid!
    $projectId: uuid!
    $fromDate: timestamptz!
  ) {
    runs(
      where: {
        checklist: {
          project_id: { _eq: $projectId }
          is_deleted: { _is_null: true }
        }
        is_deleted: { _is_null: true }
        checklist_version_id: { _is_null: false }
        created_at: { _gte: $fromDate }
        runs_assignments: { userByUserId: { id: { _neq: $userId } } }
      }
      order_by: { created_at: desc }
    ) {
      id
      name
      runs_assignments {
        userByUserId {
          displayName
          email
        }
      }
    }
  }
`;

export const GET_TIME_SPENT_ON_CHECKLIST = gql`
  query GetProjectTimingWithChecklist($id: uuid!, $fromDate: timestamptz!) {
    timing_events: events(
      where: {
        project_id: { _eq: $id }
        created_at: { _gte: $fromDate }
        event_type: {
          _in: ["run_inprogress", "run_completed", "checklist_created"]
        }
        is_run_deleted: { _is_null: true }
      }
    ) {
      run_id
      event_type
      created_at
      checklist_id
      checklist {
        id
        title
      }
      run {
        name
        run_checklist {
          id
          title
        }
        checklist {
          id
          title
        }
      }
    }
  }
`;

export const GET_PROJECT_CHECKLIST_STATUS = gql`
  query GetProjectChecklistCounts($projectId: uuid!, $fromDate: timestamptz!) {
    created: events_aggregate(
      where: {
        project_id: { _eq: $projectId }
        event_type: { _eq: "run_created" }
        is_run_deleted: { _is_null: true }
        created_at: { _gte: $fromDate }
      }
    ) {
      aggregate {
        count
      }
    }

    completed: events_aggregate(
      where: {
        project_id: { _eq: $projectId }
        event_type: { _eq: "run_completed" }
        is_run_deleted: { _is_null: true }
        created_at: { _gte: $fromDate }
      }
    ) {
      aggregate {
        count
      }
    }

    inProgress: events_aggregate(
      where: {
        project_id: { _eq: $projectId }
        event_type: { _eq: "run_inprogress" }
        is_run_deleted: { _is_null: true }
        created_at: { _gte: $fromDate }
      }
    ) {
      aggregate {
        count
      }
    }

    overdue: events_aggregate(
      where: {
        project_id: { _eq: $projectId }
        event_type: { _eq: "run_created" }
        is_run_deleted: { _is_null: true }
        run_due_at: { _lt: "now()" }
        run_checklist: {
          _or: [
            { is_completed: { _eq: false } }
            { is_completed: { _is_null: true } }
          ]
        }
        created_at: { _gte: $fromDate }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;
